module.exports = __webpack_public_path__ + "img/bookshelf10.e7949bd6.jpg";